import styled, { css } from 'styled-components';
import type { Entries, TextStyledProps } from './Text.typed';
import { media } from '../../../helpers/breakpoints';

// Correctly typed Object.entries() from here: https://stackoverflow.com/questions/60141960/typescript-key-value-relation-preserving-object-entries-type
const getEntries = <T extends object>(obj: T) =>
  Object.entries(obj) as Entries<T>;

export const Text = styled.p<TextStyledProps>`
  ${({ display }) => (display ? `display: ${display};` : '')}
  ${({ theme, color }) => (color ? `color: ${theme.colors[color]};` : '')}
  text-align: ${({ align }) => align ?? 'left'};
  ${({ theme, size }) => (size ? theme.fontSize[size] : '')};
  // Output the desired font size for each desired breakpoint
  ${({ theme, responsiveSizes }) =>
    responsiveSizes
      ? getEntries(responsiveSizes).map(([breakpoint, fontSize]) =>
          fontSize ? `${media[breakpoint]} {${theme.fontSize[fontSize]};}` : '',
        )
      : ''}
  ${({ theme, weight }) =>
    weight ? `font-weight: ${theme.fontWeight[weight]};` : ''}

  ${({ $underline }) =>
    $underline &&
    css`
      text-decoration: ${() => {
        switch ($underline) {
          case 'dotted':
            return 'underline dotted';
          case 'dashed':
            return 'underline dashed';
          default:
            return 'underline';
        }
      }};
      text-underline-offset: 0.5rem;
    `}
`;
